import React from 'react'
import Image from 'components/Image'
import logUtil from 'utils/log'
import FlexColumn from 'components/FlexColumn'
import trimStringUtil from 'utils/string/trim'
import removeNbspStringUtil from 'utils/string/remove-nbsp'
import H3 from 'components/H3'

const TITLE = 'About this item'
/**
 * @param props
 * @param props.bodyHtml
 * @param props.aboutImageUrl
 * @returns {JSX.Element}
 * @constructor
 */
export default function QuickShopProductSidebarAboutThisItem (props) {
  const { bodyHtml, aboutImageUrl } = props
  logUtil('QuickShopProductSidebarAboutThisItem').debug('props=', props)
  return (
    <FlexColumn className='quick-shop-product-sidebar-about-this-item'>
      <H3>{TITLE}</H3>
      <div className='quick-shop-product-sidebar-about-this-item-content'>
        {!!aboutImageUrl && (
          <div className='quick-shop-product-sidebar-about-this-item-image'>
            <Image
              src={aboutImageUrl}
              shouldLazyLoad
            />
          </div>
        )}
        <div className='quick-shop-product-sidebar-about-this-item-body' dangerouslySetInnerHTML={{ __html: trimStringUtil(removeNbspStringUtil(bodyHtml)) }} />
      </div>
    </FlexColumn>
  )
}
